import React from 'react';

export default function RejectedBubbles({fill = '#ED2E7E'}) {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.1992 0.123047C13.6289 0.123047 0.199219 13.5527 0.199219 30.123C0.199219 46.6934 13.6289 60.123 30.1992 60.123C46.7695 60.123 60.1992 46.6934 60.1992 30.123C60.1992 13.5527 46.7695 0.123047 30.1992 0.123047ZM39.5859 35.6309C40.6846 36.7295 40.6846 38.509 39.5859 39.6082C38.4866 40.7075 36.7078 40.7066 35.6086 39.6082L30.1992 34.0957L24.6879 39.607C23.5886 40.7064 21.8098 40.7054 20.7105 39.607C19.6119 38.5084 19.6119 36.7289 20.7105 35.6297L26.2219 30.1184L20.707 24.5098C19.6084 23.4111 19.6084 21.6316 20.707 20.5324C21.8057 19.4332 23.5852 19.4338 24.6844 20.5324L30.1992 26.1504L35.7105 20.6391C36.8092 19.5404 38.5887 19.5404 39.6879 20.6391C40.7871 21.7377 40.7865 23.5172 39.6879 24.6164L34.1766 30.1277L39.5859 35.6309Z"
                fill={fill}
            />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./components/rejected_bubbles/index.js